import { ExpenseContext, ContextExpense } from './expense-context';
import { PropsWithChildren, useEffect, useState } from 'react';
import { Expense } from '../../shared/models/expense';
import amountService from '../../shared/services/amount.service';

export const ExpenseProvider = ({ children }: PropsWithChildren) => {
	const [expense, setExpense] = useState<ContextExpense>();

	useEffect(() => {
		return () => {
			setExpense(undefined);
		};
	}, []);

	const getFinalExpense = () => {
		if (!expense) {
			return undefined;
		}
		const finalExpense: Expense = {
			...expense,
			id: expense.id ?? '',
			description: expense.description ?? '',
			currency: (expense.currency?.length ?? 0) > 0 ? expense.currency : '₹',
			amount: amountService.getAmount(expense.amount),
			creditors:
				expense.creditors?.map(creditor => ({
					...creditor,
					id: creditor.id,
					amount: amountService.getAmount(creditor.amount),
					currency: (creditor.currency?.length ?? 0) > 0 ? (creditor.currency ?? '₹') : '₹',
				})) ?? [],
			debtors:
				expense.debtors?.map(debtor => ({
					...debtor,
					id: debtor.id,
					amount: amountService.getAmount(debtor.amount),
					currency: (debtor.currency?.length ?? 0) > 0 ? (debtor.currency ?? '₹') : '₹',
				})) ?? [],
		};
		return finalExpense;
	};

	return (
		<ExpenseContext.Provider
			value={{
				expense,
				setExpense,
				getFinalExpense,
			}}>
			{children}
		</ExpenseContext.Provider>
	);
};
